module.exports = __webpack_public_path__ + "static/media/simple_hd_viewer.454d59fa.png";